import { CheckIcon, MinusIcon } from '@heroicons/react/solid';
import { PricingWidget } from '../components/PricingWidget';
const Subscription = () => {
    return <PricingWidget />;
};

export default Subscription;
